/**
 * Simple AngularJS controller to use when the entire view is managed by Vue.
 * Note: There is no template required here.
 */

/**
 * @param {NavigationService} navigationService
 */
export const VuePlaceholderCtrl = function (
    navigationService,
) {
    navigationService.showNav();
};
